import { createAction } from 'typesafe-actions';
import { ErrorState } from './types';

const setError = createAction('@em/error/set', action => (error: ErrorState) => action(error));

const dropError = createAction('@em/error/drop', action => () => action());

export const errorActions = { setError, dropError };
